import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
    // Dispatch custom event to notify components that cookies were accepted
    window.dispatchEvent(new CustomEvent('cookieConsentAccepted'));
    // Small delay before reload to ensure event is processed
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-slate-200 shadow-2xl p-6 z-[100] rounded-t-2xl animate-fade-in">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between text-slate-900 text-base gap-4">
        <p className="mb-2 md:mb-0 font-medium">
          {t('cookieBannerText')}
        </p>
        <div className="flex items-center gap-4">
          <a href="/cookies" className="underline whitespace-nowrap text-slate-700 hover:text-emerald-600 font-semibold transition-colors">
            {t('cookieBannerLearnMore')}
          </a>
          <button
            onClick={handleAccept}
            className="bg-gradient-to-r from-emerald-400 to-emerald-600 text-white px-6 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl hover:from-emerald-500 hover:to-emerald-700 transition-all"
          >
            {t('cookieBannerAccept')}
          </button>
          <button
            onClick={handleDecline}
            className="bg-slate-300 text-slate-900 px-6 py-2 rounded-lg font-semibold shadow hover:bg-slate-400 transition-colors"
          >
            {t('cookieBannerDecline')}
          </button>
      </div>
     </div>
    </div>
  );
};

export default CookieBanner;